module.exports = __webpack_public_path__ + "img/asset-group-list.ce0fee95.png";